import {RulePart} from "./RulePart";
import {IRulePartParams} from "./index";
import * as ko from "knockout";
import {nsRule} from "./nsRule";
import {nsFa} from "../../../fa/fn";
import {ObjectTypeId, TEXT_WRAPPER_END, TEXT_WRAPPER_START} from "../../../../constants";
import {nsSyncFields} from "../../../../req/nsSyncFields";
import {ISyncField} from "../../../../index";
import {_} from 'lodash';
import {IComboboxV2Options} from "../../../combobox/v2";
import {createBaseTextMatch} from "../../../combobox/v2-sources";
import {NO_DATA_MESSAGE} from "../../../../constants/Language";
import {global, lm} from "../../../../appContext";
import {getObjectDefinition} from "../../../../util/misc";
import InputMode = nsRule.InputMode;
import i = nsFa.i;
import attributeHtml from './attribute.html?raw';

export let template = attributeHtml;

export class viewModel extends RulePart {

    private readonly ObjectTypeId = ObjectTypeId;
    private readonly InputMode = InputMode;
    private readonly attributeInputMode: KnockoutObservable<InputMode | null> = ko.observable(null);
    private readonly isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    private readonly getsyncfieldsPromiseRequest = nsSyncFields.getSyncFieldsPromiseRequest()
    private readonly data: KnockoutObservableArray<ISyncField> = ko.observableArray<ISyncField>([])
    private readonly selected: KnockoutObservable<ISyncField | null> = ko.observable(null)
    private comboboxParams!: IComboboxV2Options<ISyncField>
    private inputValue: KnockoutObservable<string | null> = ko.observable(null);

    constructor(params: IRulePartParams) {
        super(params);

        const attributeInputMode = (this.ruleMutable.attribute() ?? '').indexOf('[') == -1 ? InputMode.Select : InputMode.Text;
        this.attributeInputMode(attributeInputMode);

        this.kosub.subscribeChanged(this.attributeInputMode, (newValue: InputMode | null, oldValue: InputMode | null) => {
            if (oldValue == InputMode.Select && newValue == InputMode.Text) {
                const name = this.selected()?.name;
                if (name) {
                    this.ruleMutable.attribute(`[${name}]`)
                }
                return
            }
            if (oldValue == InputMode.Text && newValue == InputMode.Select) {
                const attr = this.ruleMutable.attribute() as string;
                if (attr.startsWith(TEXT_WRAPPER_START) && attr.endsWith(TEXT_WRAPPER_END)) {
                    const name = attr.substring(1, attr.length - 1)
                    if (name) {
                        const item = this.data().find((o: ISyncField) => o.name == name) ?? null
                        this.selected(item)
                        this.ruleMutable.attribute(item?.name ?? '')
                        return
                    }
                }
                this.ruleMutable.attribute('')
            }
        })

        this.kosub.subscribe(this.ruleMutable.attribute as KnockoutObservable<string>, (val: string) => {
            if (val == 'EntryType') {
                if (!this.ruleMutable.argumentoperator()) {
                    this.ruleMutable.argumentoperator('Er lik en av');
                }
            }
        });

        this.kosub.subscribe(global.sourceTranslation, () => {
            if (this.attributeInputMode() == InputMode.Select && this.comboboxParams) {
                this.inputValue(this.getLabel(this.selected()))
            }
        })

        this.init()
    }

    private init() {
        this.isReady(false)
        this.getsyncfieldsPromiseRequest
            .request({
                objectTypeIds: [this.objectType().id, ObjectTypeId.History]
            })
            .then((data: ISyncField[]) => {
                this.data(data)
                if (this.inputValue() == null) {
                    this.inputValue('')
                }
                const labelFn = this.getLabel
                this.comboboxParams = {
                    data: this.data,
                    selected: this.selected,
                    input: this.inputValue as KnockoutObservable<string>,
                    emptyPreparedListMessage: NO_DATA_MESSAGE,
                    inputAttrs: {placeholder: lm.t('choose|td') ?? ''},
                    initialMatch: o => o.name == this.ruleMutable.attribute(),
                    option: {
                        label: labelFn,
                        match: createBaseTextMatch(labelFn),
                        html: o => {
                            const objDef = getObjectDefinition(o.objecttypeid)
                            return `${i(objDef?.icon ?? '')} ${this.getLabel(o)}`
                        },
                        tooltip: o => {
                            const objDef = getObjectDefinition(o.objecttypeid)
                            return `${this.getLabel(o)} [${objDef?.translation ?? ''}]`
                        },
                    },
                    prepareData: {
                        sort: (items) => _.sortBy(items, [
                            (o: ISyncField) => o.objecttypeid,
                            (o: ISyncField) => this.getLabel(o).toLowerCase(),
                        ]),
                    },
                    onSelect: (o) => {
                        if (o != null) {
                            this.selected(o)
                            this.ruleMutable.attribute(o?.name ?? null)
                        }
                    },
                }
                this.isReady(true)
            })
    }

    private getLabel(o: ISyncField | null | undefined): string {
        if (!o) {
            return ''
        }
        const n = o.name
        const d = o.displayname
        if (!d) {
            return n
        }
        return global.sourceTranslation()
            ? `${d} (${n})`
            : `${n} (${d})`
    }

    override dispose() {
        super.dispose();
        this.getsyncfieldsPromiseRequest.abort()
    }
}
